<script setup lang="ts">
// A secret typed and kept masked, shown on request (a push destination's
// stream key, the broadcaster directory's keys and passwords: DECISIONS
// 2026-10-06 "broadcaster directory").
import { ref } from 'vue'

defineOptions({ inheritAttrs: false }) // placeholder, data-test and the like go on the input

const model = defineModel<string | undefined>({ required: true })
const shown = ref(false)
</script>

<template>
    <div class="flex min-w-0 gap-1.5">
        <input
            v-model="model"
            :type="shown ? 'text' : 'password'"
            class="min-w-0 flex-1 font-mono tabular-nums"
            autocomplete="new-password"
            spellcheck="false"
            v-bind="$attrs"
        />
        <button
            type="button"
            class="shrink-0 btn-ghost text-xs"
            :aria-pressed="shown"
            data-test="secret-toggle"
            @click="shown = !shown"
        >
            {{ shown ? 'hide' : 'show' }}
        </button>
    </div>
</template>
